import get from 'lodash.get';

type Collection = Record<string, any>[];
type Filters = Record<string, string[] | undefined>;

const filterByParsedQueryString = (
    collection: Collection,
    filters: Filters
): Collection => {
    const filterKeys = Object.keys(filters);

    return collection.filter((item) => {
        return filterKeys.reduce((accumulator, currentValue) => {
            const filterValue = get(filters, currentValue);
            const itemValue = get(item, currentValue);

            // Keep returning false once an item already fails to match
            if (!accumulator) {
                return false;
            }

            const filterValueIsArray = Array.isArray(filterValue);
            const itemValueIsArray = Array.isArray(itemValue);

            // Filter when filterValue is an array and itemValue is a string
            if (filterValueIsArray && !itemValueIsArray) {
                return filterValue && filterValue.includes(`${itemValue}`);
            }

            // Filter when filterValue and itemValue are arrays
            if (filterValueIsArray && itemValueIsArray) {
                // Only require one value to match
                return (
                    filterValue &&
                    itemValue.some((value: any) => {
                        return filterValue.includes(`${value}`);
                    })
                );
            }

            return true;
        }, true);
    });
};

export default filterByParsedQueryString;
